import { useEffect, useState } from 'react'

import { Logic, Operator } from 'core-components/types'

import { useMarketsAllowedForUser } from '../../../../hooks/useMarketsAllowedForUser'
import { getGeoMappingCrud } from '../helpers/getGeoMappingCrud'
import { mapGeoMappingItem } from '../helpers/mapGeoMappingItem'
import { IMappedGeoMappingItem } from '../models/mappedGeoMappingItem'

export const useGeoMappingItems = (allowedCountryCodes?: string[]) => {
  /** -------------------- Variables ----------------------- */
  const [geoMappings, setGeoMappings] = useState<IMappedGeoMappingItem[]>([])

  const { allowedMarkets } = useMarketsAllowedForUser()

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    const crud = getGeoMappingCrud()

    if (allowedMarkets.length) {
      crud.setFilter({
        logic: Logic.AND,
        filters: [
          {
            logic: Logic.OR,
            filters: allowedMarkets.map((it) => ({
              operator: Operator.CONTAINS,
              field: 'GeoMarketsNew',
              value: it.Market,
            })),
          },
        ],
      })
    }

    crud.fetch().then((response) => {
      setGeoMappings(
        response.items.sort((a, b) => a.GeoMarketOrder - b.GeoMarketOrder).map(mapGeoMappingItem)
      )
    })
  }, [allowedMarkets, allowedCountryCodes])

  return geoMappings
}
